import { api } from "../../services/NetworkBase";

export async function GetAllCoolerProfiles() {
  try {
    let response = await api.get("vlp/cooler-profiles").json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function GetCoolerProfileById(profileId) {  
  try {
    let response = await api.get(`vlp/cooler-profiles/${profileId}`).json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function SaveCoolerProfile(profile) {
  try {
    let response = await api.post("vlp/cooler-profiles", { json: profile });
    return response;
  } catch (error) {
    throw error;
  }
}

export async function UpdateCoolerProfile(profile) {
  try {
    let response = await api.put("vlp/cooler-profiles", { json: profile });
    return response;
  } catch (error) {
    throw error;
  }
}

export async function DeleteCoolerProfile(profileId) {
  try {
    const encodedUrl = encodeURIComponent(profileId);
    let response = await api.delete(`vlp/cooler-profiles/${encodedUrl}`).json();
    return response;
  } catch (error) {
    throw error;
  }
}